import React, { createContext, useContext, useState } from "react";

export const AudioContext = createContext();

/**
 * Custom hook to use the AudioContext.
 * 
 * @returns {object} The current audio context value.
 * @throws Will throw an error if used outside of an AudioProvider.
 */
export function useAudio() {
  const context = useContext(AudioContext);
  if (!context) {
    // make sure to wrap the parent component with the AudioIDProvider in order to make use of the langauge context in the descending child nodes
    throw new Error("useAudioID must be used within a AudioIDProvider");
  }
  return context;
}

/**
 * AudioProvider component that provides the audio context to its children.
 * 
 * @param {React.ReactNode} children - The child components that will receive the audio context.
 * @returns {JSX.Element} The audio provider component with context.
 */
export const AudioProvider = ({ children }) => {
  const [playingAudio, setPlayingAudio] = useState();

  return (
    <AudioContext.Provider value={{ playingAudio, setPlayingAudio }}>
      {children}
    </AudioContext.Provider>
  );
};